"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlStyle = void 0;
exports.htmlStyle = "\n    html {\n        font-size: 10px;\n    }\n";
